import styled, { css } from "styled-components";
import global from "../../global";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
  gap: 16px;
`;

export const HeaderTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: var(--title);
  margin: 0;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  width: 100%;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    flex-direction: column;

    & > * {
      width: 100% !important;
      flex-shrink: 0;
    }

    & > button,
    & > div > button {
      width: 100% !important;
      justify-content: center;
    }
  }
`;

export const SearchSelectWrapper = styled.div`
  position: relative;
  height: 38px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  z-index: 1;
  width: 130px;
  flex-shrink: 0;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    height: 38px !important;
    min-height: 38px !important;
  }
`;

export const SearchSelectButton = styled.button`
  height: 38px;
  width: 130px;
  padding: 0 16px;
  border: 1px solid var(--fixit);
  border-radius: 20px;
  background-color: transparent;
  color: var(--fixit);
  font-size: 14px;
  font-weight: 600;
  outline: none;
  cursor: pointer;
  box-sizing: border-box;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  svg {
    pointer-events: none;
    color: var(--fixit);
    width: 16px;
    height: 16px;
    stroke-width: 2.5px;
  }

  &:hover {
    background: rgba(152, 53, 209, 0.05);
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    height: 38px !important;
    min-height: 38px !important;
  }
`;

export const SearchContainer = styled.form`
  display: flex;
  width: 350px;
  height: 38px;
  box-sizing: border-box;
  position: relative;

  ${SearchSelectWrapper} + input {
    border-radius: 0 !important;
    border-left: none !important;
    margin-left: -20px !important;
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    width: 100% !important;
    min-width: unset;
    height: 38px !important;
    min-height: 38px !important;
    flex-shrink: 0;
  }
`;

export const SearchInput = styled.input<{ $hasText?: boolean }>`
  flex: 1;
  height: 38px;
  padding: 0 52px 0 16px;
  background: transparent;
  border: 1px solid ${({ $hasText }) => ($hasText ? "var(--fixit)" : "var(--light-gray)")};
  border-right: none;
  border-radius: 20px 0 0 20px;
  font-size: 14px;
  color: var(--title);
  outline: none;
  transition: all 0.2s ease-in-out;
  box-sizing: border-box;
  margin-right: -20px;
  min-width: 0;

  &::placeholder {
    color: var(--gray);
  }

  &:focus {
    border-color: var(--fixit);
    z-index: 2;
    position: relative;
  }

  ${SearchSelectWrapper} + & {
    border-radius: 0;
    border-left: none;
    margin-left: -20px;
    padding-left: 28px;
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    height: 38px !important;
    min-height: 38px !important;
  }
`;

export const ClearSearchButton = styled.button<{ $hasSelect?: boolean; $onRight?: boolean }>`
  position: absolute;
  left: ${({ $hasSelect, $onRight }) => ($onRight ? "auto" : $hasSelect ? "138px" : "12px")};
  right: ${({ $onRight }) => ($onRight ? "50px" : "auto")};
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: var(--gray);
  cursor: pointer;
  z-index: 3;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  transition: all 0.2s;

  &:hover {
    color: var(--fixit);
    background-color: rgba(152, 53, 209, 0.1);
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const SelectedFilterBadge = styled.div`
  flex: 1;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 44px 0 16px;
  background: transparent;
  border: 1px solid var(--light-gray);
  border-right: none;
  box-sizing: border-box;
  margin-right: -20px;
  min-width: 0;
  cursor: default;

  ${SearchSelectWrapper} + & {
    border-radius: 0;
    border-left: none;
    margin-left: -20px;
    padding-left: 28px;
  }
`;

export const SelectedFilterTag = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(152, 53, 209, 0.08);
  border: 1px solid rgba(152, 53, 209, 0.2);
  color: var(--fixit);
  padding: 4px 10px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 500;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
`;

export const SelectedFilterText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 1;
`;

export const SelectedFilterRemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: var(--fixit);
  cursor: pointer;
  padding: 0;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  transition: background 0.2s;

  &:hover {
    background-color: rgba(152, 53, 209, 0.15);
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const SearchButton = styled.button<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 38px;
  background: transparent;
  border: 1px solid var(--fixit);
  border-radius: 20px;
  color: var(--fixit);
  cursor: pointer;
  transition: all 0.2s;
  box-sizing: border-box;
  margin-left: -20px;
  z-index: 4;
  position: relative;
  flex-shrink: 0;

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
      cursor: not-allowed;
    `}

  &:hover {
    background: rgba(152, 53, 209, 0.05);
  }

  svg {
    width: 20px;
    height: 20px;
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    height: 38px !important;
    min-height: 38px !important;
    width: 60px !important;
    min-width: 60px;
  }
`;

export const SearchSuggestionsList = styled.ul`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background-color: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  padding: 4px 0;
  margin: 0;
  list-style: none;
  z-index: 100;
  overflow: hidden;
`;

export const SearchSuggestionItem = styled.li`
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  color: var(--title);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background-color: rgba(152, 53, 209, 0.05);
    color: var(--fixit);
  }
`;

export const CustomerInfoCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  max-width: 260px;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    max-width: 100%;
  }
`;

export const CustomerDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const CustomerName = styled.span<{ color?: string }>`
  font-size: 15px;
  font-weight: 600;
  color: ${(props) => props.color || "var(--black)"};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CustomerLocation = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: var(--gray);
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DocumentText = styled.span`
  font-size: 14px;
  color: var(--dark-gray);
  font-weight: 400;
  white-space: nowrap;
`;

export const ManagerText = styled.span`
  font-size: 14px;
  color: var(--black);
  font-weight: 600;
`;

export const PhoneText = styled.span`
  font-size: 14px;
  color: var(--dark-gray);
  font-weight: 400;
  white-space: nowrap;
`;

export const StatusBolinha = styled.div<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  flex-shrink: 0;
  transition: all 0.2s ease;
`;

export const StatusCell = styled.div<{ color?: string }>`
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 13px;
  color: ${(props) => props.color || "var(--text)"};
  white-space: nowrap;
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  width: 100%;
  gap: 12px;
`;

export const EmptyText = styled.span`
  font-size: 14px;
  color: var(--gray);
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
`;

export const ActionButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DescriptionHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const DescriptionHeaderText = styled.span`
  font-family: Roboto, sans-serif;
  font-size: 24px;
  font-weight: bold;
  color: var(--fixit);
  line-height: 1.2;
`;

export const HeaderCountBadge = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: var(--fixit);
  background: rgba(152, 53, 209, 0.08);
  border: 1px solid rgba(152, 53, 209, 0.2);
  border-radius: 12px;
  padding: 1px 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  box-sizing: border-box;
`;

export const ActionText = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

export const SituationMenuTitle = styled.div`
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 600;
  color: var(--gray);
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const SituationOptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const StatusMenuTitle = SituationMenuTitle;
export const StatusOptionRow = SituationOptionRow;

export const SortableHeader = styled.span<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  color: ${({ $active }) => ($active ? "var(--fixit)" : "inherit")};
  font-weight: ${({ $active }) => ($active ? 600 : 500)};

  svg {
    width: 15px;
    height: 15px;
    flex-shrink: 0;
  }
`;

